import axios from "axios";
import { api } from "./api_route";

export const createTicket = async (formData) => {
  const response = await axios.post(`${api}/tickets/create`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const updateTicket = async (ticketId, formData) => {
  const response = await axios.put(
    `${api}/tickets/update/${ticketId}`,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return response.data;
};

export const deleteTicket = async (ticketId) => {
  const response = await axios.delete(`${api}/tickets/delete/${ticketId}`);
  return response.data;
};

export const deleteTicketDocument = async ({ TicketDocId, userId }) => {
  try {
    const response = await axios.delete(`${api}/tickets/deleteDocument`, {
      data: { TicketDocId, userId },
    });
    return response.data;
  } catch (error) {
    console.error("deleteTicketDocument error:", {
      message: error.message,
      response: error.response?.data,
    });
    throw new Error(
      error.response?.data?.message || "Failed to delete ticket document"
    );
  }
};

export const getTickets = async (userId) => {
  const response = await axios.get(`${api}/tickets/list`, {
    params: { userId },
  });

  return response.data.data; // contains tickets or []
};


export const ticketDocumentDownload = async (values) => {
  try {
    const response = await axios.get(
      `${api}/documents/ticketDocuments/${values.original.documentNewName}`,
      { responseType: "blob" }
    );
    return response.data;
  } catch (error) {
    console.error("ticketDocumentDownload error:", error);
    return null;
  }
};
